import React from "react";
import ModalWindow from "../Shared/ModalWindow";

function ConfirmModal (props) {

    const hide = true,
        confirmBody =

            (<div>
            <p>
{props.question}
</p>
            {props.modalId == "generateAddToCartPopup" ? <button className="btn btn-danger modalButton"
onClick={props.onClickYes}>
{props.btnText1}
</button>
             : <button className="btn btn-danger modalButton"
data-dismiss="modal"
onClick={props.onClickYes}>
{props.btnText1}
</button>
             }
        <button className="btn btn btn-secondary modalButton"
hidden={props.btnText2 === undefined}
data-dismiss="modal"
onClick={props.onClickCancel}>
{props.btnText2}
</button>
        </div>);

    return (
        <ModalWindow
            hideCloseButton={hide}
            modalBody={confirmBody} // Todo: put text in common data store
            modalId={props.modalId}
            modalTitle={props.modalTitle}
        />
    );

}

export default ConfirmModal;
